import React from "react";
import OnboardingLayout from "./OnboardingLayout";
import { HiArrowRight } from "react-icons/hi";

interface StepCompleteProps {
  onFinish?: () => void;
  hasExistingPersonas?: boolean;
  onExit?: () => void;
  isLoading?: boolean;
  hasError?: boolean;
}

function StepComplete({ onFinish, hasExistingPersonas, onExit, isLoading, hasError }: StepCompleteProps) {
  return (
    <OnboardingLayout showProgress progressValue={1} hasExistingPersonas={hasExistingPersonas} onExit={onExit}>
      <div className="px-8 pb-10 pt-6 space-y-8">
        <div className="flex items-start gap-4">
          <div className="rounded-3xl bg-[rgba(162,187,191,0.1)] p-2">
            <span role="img" aria-label="sparkles">
              ✨
            </span>
          </div>
          <div>
            <p className="text-base font-semibold text-eai-dark">
              {isLoading ? "Personalizing your experience…" : "You're all set!"}
            </p>
            <p className="text-sm text-gray-500">
              {isLoading ? "Hang tight while we set up your profile." : "Your workspace is ready. Here's what I can help you with:"}
            </p>
          </div>
        </div>

        <div className="flex flex-col items-end gap-2">
          {hasError && (
            <p className="text-sm text-red-500">
              Something went wrong setting up your profile. You can still continue.
            </p>
          )}
          <button
            type="button"
            onClick={onFinish}
            disabled={isLoading}
            className="inline-flex items-center gap-2 rounded-lg bg-eai-primary-accent px-6 py-2 text-sm font-medium text-white transition hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading && (
              <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
              </svg>
            )}
            {isLoading ? "Generating…" : hasError ? "Continue to Home" : "Let's go"}
            {!isLoading && <HiArrowRight />}
          </button>
        </div>
      </div>
    </OnboardingLayout>
  );
}

export default StepComplete;
